export enum tabStatus {
  PENDING = "Pending",
  SKIPPED = "Skipped",
  INPROGRESS = "In-Progress",
  COMPLETED = "Completed",
  SYNC_PENDING = "Sync-Pending",
  REDO = "Redo Reconciliation",
  APPROVED = "Approved"
}
